import React from 'react';
import { Link } from 'react-router-dom';
import GuidePageLayout from '../../components/seo/GuidePageLayout';

const FREE_TRIAL_URL = 'https://buy.stripe.com/5kA6rt11z6Dw06YbII';

export default function StakingAndRiskControls() {
  return (
    <GuidePageLayout currentPath="/staking-and-risk-controls">
      <h1>Staking &amp; risk controls</h1>
      <p>
        Horse Racing Oracle is designed around <strong>disciplined staking</strong> and <strong>limits</strong> so
        automation does not mean &quot;unbounded exposure.&quot; Gambling can lose money; no strategy removes risk. The
        product aims to apply your chosen rules consistently on UK Betfair horse racing markets.
      </p>

      <h2>Daily profit target (capped)</h2>
      <p>
        You can set a daily profit target so that, once reached, the system stops placing bets for that day. The product
        enforces a <strong>maximum daily profit target</strong> relative to your balance (see{' '}
        <Link to="/faqs">FAQs</Link> for the current cap). This is a risk control, not a promise of profits.
      </p>

      <h2>Percentage staking</h2>
      <p>
        Percentage staking sizes stakes as a fraction of your live balance (for example configurable percentages offered
        in the app). This can reduce the chance of over-staking after losses or under-staking after wins, compared to
        fixed amounts—though it does not eliminate drawdowns.
      </p>

      <h2>Bankroll and Betfair minimums</h2>
      <p>
        Betfair imposes minimum stakes; very small balances may limit how flexibly strategies can run. Our{' '}
        <Link to="/faqs">FAQs</Link> note practical minimum balance guidance for certain modes—treat this as
        operational guidance, not financial advice.
      </p>

      <h2>Responsible use</h2>
      <p>
        Only bet with money you can afford to lose. If you need support, use the resources linked in our site footer
        (e.g. BeGambleAware, GamStop). Read <Link to="/who-its-for">Who it&apos;s for</Link> for fit and expectations.
      </p>

      <p>
        Technical overview of the wider system: <Link to="/how-it-works">How it works</Link>. Connection details:{' '}
        <Link to="/betfair-connection-and-security">Betfair connection &amp; security</Link>.
      </p>

      <div className="guideCta">
        <p className="guideCtaTitle">Try the product on your terms</p>
        <a
          className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-gradient-to-r from-primary-200 via-primary-100 to-primary-200 hover:from-primary-100 hover:to-primary-100 transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5"
          href={FREE_TRIAL_URL}
          rel="noopener noreferrer"
        >
          Start free trial
          <svg className="ml-2 -mr-1 w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </a>
      </div>
    </GuidePageLayout>
  );
}
